import React, { useEffect, useMemo, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { Elements } from '@stripe/react-stripe-js'
import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { AppConstants, LeadStage } from 'AppConstants/AppConstants'
import Header from 'components/Header'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { CheckoutFormSetup } from './CheckoutForm'
import styles from './Payment.module.scss'

const PaymentSetupBooking = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [disableBackButton, setDisableBackButton] = useState(false)
  const [clientSecret, setClientSecret] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  //cardPayment
  const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY || ''
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

  const getPaymentIntentForCardDetails = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
      }

      const response = await fetch(`${AppConstants.API_URL}/payment-plan/change-payment-method`, {
        method: 'POST',
        body: JSON.stringify({}),
        headers: headers,
      })

      const data = await response.json()

      if (!response.ok) return null

      return data.data
    } catch (err: any) {
      console.log(err?.response?.data || err)
      return null
    }
  }

  const options: StripeElementsOptions = {
    clientSecret: clientSecret || undefined,
    appearance: {
      // theme: 'stripe',
      variables: {
        colorPrimary: 'var(--color-primary)',
        colorBackground: 'var(--color-background)',
        colorText: 'var(--color-text-primary)',
        borderRadius: '8px',
      },
    },
  }

  const postLeadStage = async () => {
    await axios
      .post(
        AppConstants.API_URL + '/lead/stage/update',
        { stage: LeadStage.payment },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        },
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err?.response
      })
  }

  useEffect(() => {
    postLeadStage()
  }, [])

  useEffect(() => {
    const fetchClientSecret = async () => {
      setIsLoading(true)
      const data = await getPaymentIntentForCardDetails()
      if (data?.clientSecret) {
        setClientSecret(data.clientSecret)
      } else {
        alert('Failed to initialize payment setup. Please try again.')
      }
      setIsLoading(false)
    }

    fetchClientSecret()
  }, [])

  return (
    <div>
      <div className={styles.paymentContainer}>
        <Header
          headerText="Add Card"
          showBackButton={true}
          onBack={() => {
            disableBackButton ? undefined : navigate(`/booking/${id}/confirm-visit`)
          }}
        ></Header>
        {isLoading || !clientSecret ? (
          <div className={styles.circularProgress}>
            <CircularProgress
              size={40}
              sx={{
                color: '#007F7C',
                width: '14px',
                height: '14px',
              }}
            />
          </div>
        ) : (
          <Elements stripe={stripePromise} options={options}>
            <div className={styles.paymentContainerDetails}>
              <CheckoutFormSetup
                clientSecret={clientSecret}
                disableBackButton={() => {
                  setDisableBackButton(true)
                }}
                enableBackButton={() => {
                  setDisableBackButton(false)
                }}
              ></CheckoutFormSetup>
            </div>
          </Elements>
        )}
      </div>
    </div>
  )
}

export default PaymentSetupBooking
